//GLOBAL - components from npm
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import Highlighter from "react-highlight-words";
import latinize from "latinize";
// import ReactMapGL, { Marker } from "react-map-gl";
import {
  GoogleMap,
  Marker,
  LoadScript,
  useJsApiLoader,
} from "@react-google-maps/api";
import axios from "axios";

// UTILS
import unicodeToChar from "../../actions/formatUnicode";
import urlIngWeb from "../../actions/urlIngWeb";
import {
  InterationNotifier,
  RequestActiveCallSocketVoz,
  ReturningCallback,
  returnListCallQueue,
  RequestActiveCall,
  ShowInfoDisplay,
} from "../../actions";

//STYLES
import "./interaction-comment.css";

//COMPONENTS
import AttachTypeFiles from "../AttachTypeFiles/AttachTypeFiles";
import CommentImage from "../CommentImage/CommentImage";
import Typography from "../Typography";
import Audio from "../Audio/Audio";
import { Popover } from "../../actions/Tippy";
import UserPhoto from "../UserPhoto/userphoto";

//SERVICES - api, conectors...
import { connection_platform } from "../../services/api";

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...
import { ReactComponent as IconClips } from "../../build/images/chatIcons/Clips.svg";
import { ReactComponent as Tick } from "../../build/images/chatIcons/double-tick.svg";
import { ReactComponent as ErrorCircle } from "../../build/images/chatIcons/info-circle.svg";
import { ReactComponent as IconMoreVertical } from "../../build/images/MoreVertical.svg";
import { locale } from "moment";
import MailContainer from "../mail-section/MailContainer";
import InteractionEmail from "../InteractionEmail/InteractionEmail";
import blockClick from "../../actions/blockClick";
import { formatTextAndUnicode } from "../../utils/formatTextAndUnicode";

let pathname = localStorage.getItem("pathname");
let port = localStorage.getItem("port");

const parse = require("html-react-parser");

function escapeHtml(str) {
  if (!str) return str;
  return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

function InteractionComment({
  text,
  id,
  date,
  attachment,
  type,
  direction,
  name,
  mimetype,
  mimetypeId,
  size,
  inputSearch,
  buttons,
  botId,
  reply,
  buttonResponse,
  typeName,
  location,
  allInfo,
  handleReply,
  titleOptions = true,
  contactInfo,
  contactLinkAdd,
  actionCallInfo,
}) {
  const dispatch = useDispatch();
  const InfoUsers = useSelector((state) => state.informationusers);
  const IPCurrent = useSelector((state) => state.ipcurrent);
  const PermissionRouter = useSelector((state) => state.routergroups);
  const ContactId = useSelector((state) => state.atendimento);
  const OutBandService = useSelector((state) => state.outservices);
  const StatusAgent = useSelector((state) => state.status);
  const listCallQueue = useSelector((state) => state.listcallqueue);
  const AtdSimult = useSelector((state) => state.atdsimult);
  //STATES
  const [interactionComment, setInteractionComment] = useState(
    escapeHtml(text),
  );
  const [interactionEmail, setInteractionEmail] = useState({
    id: allInfo.id ? allInfo.id : allInfo.messageid,
    cdr: 0,
    operator: allInfo.agente ? allInfo.username : allInfo.cliente,
    date_sending: allInfo.data_hora_envio,
    body_msg: allInfo.messagem,
    attachments: [],
    recipients: [],
    externalcode: allInfo.id,
    favorite: allInfo.favorite,
    caption: allInfo.caption,
  });
  const [commentImg, setCommentImg] = useState(false);
  const [commentVideo, setCommentVideo] = useState(false);
  const [buttonsComment, setButtonsComment] = useState([]);
  const [visible, setVisible] = useState(false);
  const [stringAnterior, setStringAnterior] = useState("");
  const [viewport, setViewport] = useState({
    latitude: location ? parseFloat(location.latitude) : 0,
    longitude: location ? parseFloat(location.longitude) : 0,
    zoom: 14,
    maxZoom: 16,
  });
  const [map, setMap] = React.useState(null);
  const [statusDownload, setStatusDownload] = useState("Download");

  //GENERAL
  let textInteraction = text;
  let buttonsInteraction = [];
  const mimetypesPrincipal = [
    "image",
    "voice",
    "document",
    "audio",
    "txt",
    "video",
  ];
  const searchWords = inputSearch.split(/\s/).filter((word) => word);
  const TOKEN =
    "pk.eyJ1IjoiZ2FicmllbGIxOCIsImEiOiJjazR4NW9yYXAyb3dkM25sYWQ1ZHYycThuIn0.1MSSnEAXvqfNvl8yqrJirg";
  const typemon = allInfo.typemon
    ? parseInt(allInfo.typemon)
    : parseInt(allInfo.mon_type_id);

  // if (mimetypeId === 30 && isJson(text) === true) {
  //   textInteraction = tratarBOT(textInteraction);
  // }

  // if (typeName === "Interactive" && isJson(text) === true) {
  //   textInteraction = tratarBOT(textInteraction);
  // }

  // if (typeName === "location" && isJson(text) === true) {
  //   textInteraction = tratarBOT(textInteraction);
  // }

  //REDUX - Selectors

  //FUNCTIONS
  const show = () => setVisible(true);

  const hide = () => {
    setVisible(false);
  };

  function isJson(item) {
    item = typeof item != "string" ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === "object" && item != null) {
      return true;
    }

    return false;
  }

  //ANTIGO TRATAMENTO
  // function tratarUnderline(valor) {
  //   valor = valor.split(" ");
  //   const expresionRegular = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   let valorFim = [];
  //   for (let variavel of valor) {
  //     if (!expresionRegular.test(variavel)) {
  //       variavel = variavel
  //         .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
  //         .replace(/(^|\s)_([^_]+?)_(?=\s|$)/gm, "$1<em>$2</em>")
  //         .replaceAll("\n", "</br>")
  //         .replaceAll('"}', "")
  //         .replaceAll("\\n", "</br>")
  //         .replaceAll("\n", "</br>")
  //         .replaceAll("\\r", "")
  //         .replaceAll("\r", "");
  //       // .replace(/_(.*?)_/g, "<em>$1</em>")
  //     }
  //     valorFim.push(unicodeToChar(variavel));
  //   }
  //   return valorFim
  //     .join(" ")
  //     .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>");
  // }

  //NOVO TRATAMENTO
  function tratarUnderline(valor) {
    const expresionRegular = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!expresionRegular.test(valor)) {
      valor = valor
        .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
        .replace(/(^|\s)_([^_]+?)_(?=\s|$)/gm, "$1<em>$2</em>")
        .replaceAll("\n", "</br>")
        .replaceAll('"}', "")
        .replaceAll("\\n", "</br>")
        .replaceAll("\n", "</br>")
        .replaceAll("\\r", "")
        .replaceAll("\r", "");
    }

    return unicodeToChar(valor);
  }

  function formatarNumeros(numero) {
    // Remove todos os caracteres não numéricos
    let numeroLimpo = numero.replace(/\D/g, "");

    // Verifica o comprimento do número e formata de acordo
    if (numeroLimpo.length === 13 || numeroLimpo.length === 12) {
      // Formato: +55 71 99611-0771
      numeroLimpo = numeroLimpo.slice(2); // Remove o prefixo internacional
    } else if (numeroLimpo.length === 16) {
      // Formato: +5502171333334444
      numeroLimpo = numeroLimpo.slice(5); // Remove o prefixo internacional
    }

    // Verifica se é número de celular e adiciona o prefixo "9" após o DDD, se necessário
    if (numeroLimpo.length === 10 || numeroLimpo.length === 11) {
      const DDD = numeroLimpo.slice(0, 2);
      const numeroSemDDD = numeroLimpo.slice(2);

      // Verifica se é celular (começa com 9) ou fixo
      if (numeroSemDDD[0] >= "2" && numeroSemDDD[0] <= "5") {
        // É um número de telefone fixo
        return DDD + numeroSemDDD;
      } else if (
        (numeroSemDDD[0] === "9" && numeroSemDDD.length === 8) ||
        (numeroSemDDD[0] !== "9" && numeroSemDDD.length === 8)
      ) {
        // É um número de celular, verificando o prefixo "9" após o DDD
        return DDD + "9" + numeroSemDDD;
      } else {
        // É um número de telefone correto
        return DDD + numeroSemDDD.slice(0); // Mantém o restante do número
      }
    }

    // Caso não corresponda a nenhum formato conhecido
    return "Número de telefone em formato desconhecido";
  }

  function tratarBOT2(text) {
    let message = text.replace(/\r?\n/g, "\\n");
    let json = JSON.parse(message);
    let options = json.options;
    if (parseInt(json.MIMETYPE) === 30) {
      return setInteractionComment(json.MSG);
    } else if (parseInt(json.mimetype) >= 33 && parseInt(json.mimetype) <= 37) {
      if (json.header) {
        return setInteractionComment(`*${json.header}*\\r\\n${json.msg}`);
      } else {
        return setInteractionComment(json.msg);
      }
    } else if (json.address || json.ADDRESS) {
      return setInteractionComment(json.address || json.ADDRESS);
    } else if (json.HSM_BUTTONS) {
      return setInteractionComment(json.URL);
    } else if (json.URL) {
      return setInteractionComment(json.URL);
    }

    return setInteractionComment(escapeHtml(text));
  }

  function tratarBOT(text) {
    const sanitized = text.replace(/\r?\n/g, "\\n");
    if (isJson(sanitized) === false) return text;
    let json = JSON.parse(sanitized);
    let options = json.options;
    if (parseInt(json.MIMETYPE) === 30) {
      return json.MSG;
    } else if (
      (parseInt(json.mimetype) >= 33 && parseInt(json.mimetype) <= 37) ||
      parseInt(json.mimetype) === 50
    ) {
      if (json.header) {
        return `*${json.header}*\\r\\n${json.msg}`;
      } else {
        return json.msg;
      }
    } else if (json.address || json.ADDRESS) {
      return json.address || json.ADDRESS;
    } else if (json.HSM_BUTTONS) {
      return json.URL;
    }

    return text;
  }

  function formatEmoji(item) {
    if (item) {
      let mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1;
      try {
        mensagem_tratada =
          '{"' +
          valor +
          '": [{"mensagem_tratada":"' +
          mensagem_tratada +
          '"}]}';
        let obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada;
      } catch (e) {
        mensagem_tratada = item;
      }
      return mensagem_tratada;
    }
  }

  const ReturningCallbackIn = (
    queueid,
    inforetorno,
    recvcount,
    cdrid,
    mediaid,
    srvin,
    caller,
    called,
    cbackcount,
  ) => {
    ReturningCallback(
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called,
    )(dispatch);
    dispatch(returnListCallQueue("", queueid, "2", parseInt(cbackcount + 1)));
  };

  const solicitarChamadaAtiva = (e, mediaid, number) => {
    let permrouter = PermissionRouter;
    let outband = OutBandService;
    let infouser = InfoUsers;
    let statusAg = StatusAgent;
    let queue = listCallQueue;
    // let AtdSimult = AtdSimult;
    let ipcurrent = IPCurrent;
    let statusAgent = StatusAgent;

    if (ContactId.length !== 0) {
      localStorage.setItem("current-service", ContactId.idatendimento);
    }

    if (statusAgent.allowCall === false) {
      dispatch(InterationNotifier("Pausa não permite ativo", "permission"));
      return true;
    }

    if (document.getElementById("chat-message"))
      document.getElementById("chat-message").innerText = "";
    if (permrouter != "undefined" && permrouter != "") {
      var existeRota = false;
      var rotaencontrada = false;
      var checkRota = false;
      var rotaDefault = false;
      var rotaAlternativa = false;
      var trunk = "";
      var addtech = "";
      var scriptrunk = "";
      var operator = "";
      var trunkDef = "";
      var addtechDef = "";
      var scriptrunkDef = "";
      var operatorDef = "";
      var tech = "";
      var techDef = "";
      var idgrupo_rota = "";
      var idgrupo_rotaDef = "";
      var idgrupo_transb = "";
      var idgrupo_transbDef = "";
      var chamado = number;
      var retorno = 0;
      var checkAtd = false;
      var tipochamada = 0;
      var dddValidado = "";

      if (mediaid === 5 || mediaid === 1 || mediaid === 8) {
        chamado = chamado.replace(/\D/g, "");
      }

      if (
        permrouter[0].areacodeid != "undefined" &&
        permrouter[0].areacodeid != ""
      ) {
        var DDD = permrouter[0].areacodeid;
        var DDDPadrao = permrouter[0].areacodeid;
      } else {
        var DDD = "";
        var DDDPadrao = "";
      }

      var calledDigitado = chamado;
      var valorfixo = [1, 2, 3, 4];
      var valormovel = [5, 6, 7, 8, 9];
      if (connection_platform.remove_digits || parseInt(mediaid) !== 1) {
        if (
          chamado[0] === "0" &&
          chamado.substr(0, 2) != "00" &&
          chamado.substr(0, 4) != "0800"
        ) {
          chamado = chamado.substr(1, chamado.length - 1);
        }
      }
      if (
        (chamado.length === 12 || chamado.length === 13) &&
        chamado.substr(0, 2) != "00"
      ) {
        if (
          chamado.substr(0, 2) === "55" &&
          (mediaid === 5 || mediaid === "5") &&
          chamado.length > 11
        ) {
          chamado = chamado.substr(2, chamado.length - 1);
          calledDigitado = calledDigitado.substr(2, calledDigitado.length - 1);
        }

        dddValidado = chamado.substr(2, 2);

        if (
          !connection_platform.remove_digits &&
          parseInt(mediaid) === 1 &&
          chamado.startsWith("0")
        ) {
          dddValidado = chamado.substr(1, 2);
        }

        if (parseInt(dddValidado) != parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid == 1) tipochamada = 3;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid == 1) tipochamada = 4;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          }
        } else if (parseInt(dddValidado) == parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid == 1) tipochamada = 1;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          } else if (valormovel.indexOf(parseInt(chamado[4])) > -1) {
            if (mediaid == 1) tipochamada = 2;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          }
        }
      }
      if (
        (chamado.length === 10 || chamado.length === 11) &&
        chamado.substr(0, 4) != "0800" &&
        chamado.substr(0, 2) != "00"
      ) {
        if (!connection_platform.remove_digits && chamado[0] === "0") {
          DDD = chamado.substr(1, 2);
          chamado = chamado.substr(3, chamado.length - 1);
        } else {
          DDD = chamado.substr(0, 2);
          chamado = chamado.substr(2, chamado.length - 1);
        }

        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (
          parseInt(parseInt(DDD)) != parseInt(DDDPadrao) &&
          chamado.substr(0, 2) != "00"
        ) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid == 1) tipochamada = 3;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid == 1) tipochamada = 4;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          }
        } else if (parseInt(DDD) == parseInt(DDDPadrao)) {
          if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid == 1) tipochamada = 1;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
            if (mediaid == 1) tipochamada = 2;
            else if (mediaid == 5) tipochamada = 17;
            else if (mediaid == 8) tipochamada = 19;
            else if (mediaid === 4) tipochamada = 18;
            else if (mediaid === 6) tipochamada = 20;
            else if (mediaid === 9) tipochamada = 21;
            else if (mediaid === 10) tipochamada = 23;
            else if (mediaid === 3) tipochamada = 22;
            else if (mediaid === 2) tipochamada = 24;
            else if (mediaid === 11) tipochamada = 25;
          }
        }
        if (mediaid !== 8) {
          chamado = DDD + chamado;
        }
      } else if (chamado.length === 8 || chamado.length === 9) {
        if (chamado.length === 8 && parseInt(chamado.substr(0, 1)) >= 6) {
          if (parseInt(chamado[0]) >= 6 && parseInt(chamado[0]) <= 9) {
            chamado = "9" + chamado;
          }
        }

        if (valorfixo.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid == 1) tipochamada = 1;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
          else if (mediaid === 11) tipochamada = 25;
        } else if (valormovel.indexOf(parseInt(chamado[0])) > -1) {
          if (mediaid == 1) tipochamada = 2;
          else if (mediaid == 5) tipochamada = 17;
          else if (mediaid == 8) tipochamada = 19;
          else if (mediaid === 4) tipochamada = 18;
          else if (mediaid === 6) tipochamada = 20;
          else if (mediaid === 9) tipochamada = 21;
          else if (mediaid === 10) tipochamada = 23;
          else if (mediaid === 3) tipochamada = 22;
          else if (mediaid === 2) tipochamada = 24;
          else if (mediaid === 11) tipochamada = 25;
        }
        if (mediaid !== 1 && mediaid !== 8) {
          chamado = DDD + chamado;
          calledDigitado = DDD + calledDigitado;
        }
      } else if (chamado.substr(0, 4) == "0800" && chamado.length > 9) {
        //chamado = '0'+chamado;
        tipochamada = 8;
      } else if (chamado.substr(0, 2) == "00") {
        if (mediaid == 1) tipochamada = 5;
        else if (mediaid == 5) tipochamada = 17;
        else if (mediaid == 8) tipochamada = 19;
        else if (mediaid === 4) tipochamada = 18;
        else if (mediaid === 6) tipochamada = 20;
        else if (mediaid === 9) tipochamada = 21;
        else if (mediaid === 10) tipochamada = 23;
        else if (mediaid === 3) tipochamada = 22;
        else if (mediaid === 2) tipochamada = 24;
        else if (mediaid === 11) tipochamada = 25;
      } else {
        permrouter.map((result) => {
          if (result.calltypeid == 11) {
            if (
              parseInt(chamado) >= parseInt(result.partialnumber) &&
              parseInt(chamado) <= parseInt(result.partialnumber_end)
            ) {
              tipochamada = 11;
            }
          } else if (result.calltypeid == 6) {
            if (parseInt(chamado) === parseInt(result.partialnumber)) {
              tipochamada = 6;
            }
          }
        });
      }

      AtdSimult.map((atend) => {
        if (
          String(atend.telefone) === String(chamado) &&
          parseInt(mediaid) === parseInt(atend.idmidia)
        )
          checkAtd = true;
      });

      if (mediaid === 4) tipochamada = 18;
      else if (mediaid === 6) tipochamada = 20;
      else if (mediaid === 9) tipochamada = 21;
      else if (mediaid === 10) tipochamada = 23;
      else if (mediaid === 3) tipochamada = 22;
      else if (mediaid === 2) tipochamada = 24;
      else if (mediaid === 11) tipochamada = 25;

      if (checkAtd === false) {
        if (chamado !== "") {
          if (!isNaN(chamado)) {
            // this.setState({ senhaincorreta: "none" });

            permrouter.map((result) => {
              if (parseInt(result.idmidia) === parseInt(mediaid)) {
                if (parseInt(tipochamada) == result.calltypeid) {
                  if (parseInt(tipochamada) == 1) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator != "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 10, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 2) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      result.operator !== null &&
                      result.operator != "" &&
                      result.areacode ===
                        parseInt(
                          chamado.substr(parseInt(chamado.length) - 11, 2),
                        )
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 3) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 4) {
                    if (
                      (parseInt(chamado) >=
                        parseInt(result.areacode + result.partialnumber) &&
                        chamado <=
                          parseInt(
                            result.areacode + result.partialnumber_end,
                          )) ||
                      parseInt(chamado) ==
                        parseInt(result.areacode + result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (
                      (parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) >= parseInt(result.partialnumber) &&
                        chamado.substr(parseInt(chamado.length) - 8, 4) <=
                          parseInt(result.partialnumber_end)) ||
                      parseInt(
                        chamado.substr(parseInt(chamado.length) - 8, 4),
                      ) == parseInt(result.partialnumber)
                    ) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      checkRota = true;
                      existeRota = true;
                    } else if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 5) {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (parseInt(tipochamada) == 8) {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                      checkRota = true;
                    }
                  } else if (
                    parseInt(tipochamada) != 5 &&
                    chamado.substr(0, 2) == "00" &&
                    parseInt(result.operator) == parseInt(chamado.substr(0, 2))
                  ) {
                    trunk = result.idtrunk;
                    addtech = result.addtech;
                    scriptrunk = result.scripttrunk;
                    operator = "";
                    tech = result.tech;
                    idgrupo_rota = result.idgrupo_rota;
                    idgrupo_transb = result.idgrupo_transb;
                    rotaencontrada = true;
                    checkRota = true;
                    existeRota = true;
                  } else if (parseInt(tipochamada) == 11) {
                    permrouter.map((result) => {
                      if (result.calltypeid == 11) {
                        if (
                          parseInt(chamado) >= parseInt(result.partialnumber) &&
                          parseInt(chamado) <=
                            parseInt(result.partialnumber_end)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else if (parseInt(tipochamada) == 6) {
                    permrouter.map((result) => {
                      if (result.calltypeid == 6) {
                        if (
                          parseInt(chamado) === parseInt(result.partialnumber)
                        ) {
                          trunk = result.idtrunk;
                          addtech = result.addtech;
                          scriptrunk = result.scripttrunk;
                          operator = "";
                          tech = result.tech;
                          idgrupo_rota = result.idgrupo_rota;
                          idgrupo_transb = result.idgrupo_transb;
                          rotaencontrada = true;
                          existeRota = true;
                          checkRota = true;
                        }
                      }
                    });
                  } else {
                    if (rotaencontrada == false) {
                      trunk = result.idtrunk;
                      addtech = result.addtech;
                      scriptrunk = result.scripttrunk;
                      operator = result.operator;
                      tech = result.tech;
                      idgrupo_rota = result.idgrupo_rota;
                      idgrupo_transb = result.idgrupo_transb;
                      rotaencontrada = true;
                      existeRota = true;
                    }
                  }
                }
              }
            });
            if (existeRota == true) {
              for (let i = 0; i < queue.length; i++) {
                var numberqueue = queue[i].caller;
                //if(chamado === numberqueue){
                if (numberqueue.search(chamado) !== -1) {
                  retorno = 1;
                  var queueid = queue[i].queueid;
                  var recvcount = queue[i].recv_count;
                  var cdrid = queue[i].cdrid;
                  var srvin = queue[i].serviceinid;
                  var caller = queue[i].caller;
                  var called = queue[i].called;
                  var cbackcount = queue[i].callback_count;
                  var status = queue[i].status;
                }
              }

              if (mediaid === 5) {
                chamado = chamado.toString();
                chamado = chamado.trim();
                calledDigitado = calledDigitado.toString();
                calledDigitado = calledDigitado.trim();
              }

              if (parseInt(mediaid) === 1) {
                if (retorno === 1) {
                  dispatch(
                    RequestActiveCallSocketVoz(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      true,
                      queueid,
                      recvcount,
                      null,
                      tech,
                      idgrupo_rota,
                      idgrupo_transb,
                      ipcurrent,
                      cdrid,
                      checkRota,
                    ),
                  );

                  ReturningCallbackIn(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    statusAg,
                  );
                  dispatch(ShowInfoDisplay("Clientes"));
                  if (actionCallInfo) {
                    actionCallInfo();
                  }
                } else {
                  dispatch(
                    RequestActiveCallSocketVoz(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      chamado,
                      addtech,
                      scriptrunk,
                      operator,
                      false,
                      queueid,
                      recvcount,
                      null,
                      tech,
                      idgrupo_rota,
                      idgrupo_transb,
                      ipcurrent,
                      cdrid,
                      checkRota,
                    ),
                  );
                  ReturningCallbackIn(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    statusAg,
                  );
                  dispatch(ShowInfoDisplay("Clientes"));
                  if (actionCallInfo) {
                    actionCallInfo();
                  }
                }
              } else {
                if (retorno === 1) {
                  dispatch(
                    RequestActiveCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      calledDigitado,
                      addtech,
                      scriptrunk,
                      operator,
                      true,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                      cdrid,
                    ),
                  );
                  ReturningCallbackIn(
                    queueid,
                    true,
                    recvcount,
                    cdrid,
                    mediaid,
                    srvin,
                    caller,
                    called,
                    cbackcount,
                    statusAg,
                  );
                  dispatch(ShowInfoDisplay("Clientes"));
                  if (actionCallInfo) {
                    actionCallInfo();
                  }
                } else {
                  dispatch(
                    RequestActiveCall(
                      outband,
                      infouser,
                      trunk,
                      mediaid,
                      calledDigitado,
                      addtech,
                      scriptrunk,
                      operator,
                      false,
                      queueid,
                      recvcount,
                      cbackcount,
                      idgrupo_transb,
                    ),
                  );
                  dispatch(ShowInfoDisplay("Clientes"));
                  if (actionCallInfo) {
                    actionCallInfo();
                  }
                }
              }
              //this.props.ShowActiveCallIn('')
              //MicroModal.close('modal__falar-com-cliente');
              //this.numberToActive.value = '';
            } else {
              // this.setState({ senhaincorreta: "block" });
              document.getElementById("div_alert").innerHTML =
                "Sem rota de sa&iacute;da!";
            }
          } else {
            // this.setState({ senhaincorreta: "block" });
            document.getElementById("div_alert").innerHTML =
              "Apenas n&uacute;meros!";
          }
        } else {
          // this.setState({ senhaincorreta: "block" });
          document.getElementById("div_alert").innerHTML =
            "Informe o n&uacute;mero!";
        }
      } else {
        dispatch(
          InterationNotifier(
            "Este cliente já está sendo atendido por você",
            "call",
          ),
        );
      }
    }
  };

  function handleComment(idComment) {
    const comment = document.querySelector(`#comentario-${idComment}`);
    if (comment) {
      comment.scrollIntoView({ behavior: "smooth", block: "center" });
      comment.classList.add("comment-active");
      setTimeout(() => {
        comment.classList.remove("comment-active");
      }, 2000);
    }
  }

  function renderTitleComment() {
    return (
      <div className="comment-information-user">
        <div className="comment-information-user__container">
          <Typography.H5 color="gray-180" weight={"bold"}>
            {typemon !== 0 ? "Gestor • " : ""}
            {formatTextAndUnicode(name)}
          </Typography.H5>
          <div className="comment-information-user__infos">
            {renderFooter()}
            {InfoUsers.permdownload &&
              attachment &&
              renderTippyCommentTypeTwo()}
          </div>
        </div>
        {typemon !== 0 && (
          <div className="comment-information-user__label">
            <ErrorCircle
              className={typemon === 2 ? "icon-sussurro" : "icon-intercalar"}
            />
            <Typography.H6 color="gray-180" weight={"500"}>
              {typemon === 2
                ? "Somente para você"
                : "Mensagem enviada para você e o cliente"}
            </Typography.H6>
          </div>
        )}
      </div>
    );
  }

  function renderCommentAnswered() {
    if (reply) {
      if (mimetypesPrincipal.includes(reply.typename)) {
        return (
          <a
            href={`#comentario-${reply.id}`}
            className="comment-content__response"
            onClick={(e) => {
              e.preventDefault();
              handleComment(reply.id);
            }}
          >
            <div className="response-divider"></div>
            <div className="response-content">
              <Typography.H6 color="gray-180" weight={"bold"}>
                {formatEmoji(reply.username)}
              </Typography.H6>

              <Typography.H6 color="gray-180" weight={400}>
                <IconClips />
                &nbsp; Ir para o(s) anexo(s)
              </Typography.H6>
            </div>
          </a>
        );
      } else if (reply.typename === "Interactive") {
        let text = tratarBOT(reply.mensagem);
        let textNew = unicodeToChar(text);
        let textReplace = tratarUnderline(textNew);
        // let textReplace = textNew
        //   .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
        //   .replace(/_(.*?)_/g, "<em>$1</em>")
        //   .replace(/\_(?=\w)/, "<em>")
        //   .replace(/(?<=\w)\_/, "</em>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll('"}', "")
        //   .replaceAll("\\n", "</br>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll("\\r", "")
        //   .replaceAll("\r", "");
        const textExhib = ReactHtmlParser(`<p>${textReplace}</p>`);

        return (
          <a
            href={`#comentario-${reply.id}`}
            className="comment-content__response"
            onClick={(e) => {
              e.preventDefault();
              handleComment(reply.id);
            }}
          >
            <div className="response-divider"></div>
            <div className="response-content">
              <Typography.H6 color="gray-180" weight={"bold"}>
                {formatEmoji(reply.username)}
              </Typography.H6>

              <Typography.H6 color="gray-180" weight={400}>
                {text.length > 150
                  ? typeof textExhib === "string"
                    ? `${textExhib.slice(0, 150)}... `
                    : `${text.slice(0, 150)}... `
                  : textExhib}
              </Typography.H6>
            </div>
          </a>
        );
      } else if (reply.mimetype === 30) {
        let text = tratarBOT(reply.mensagem);
        let textNew = unicodeToChar(text);
        let textReplace = tratarUnderline(textNew);
        // let textReplace = textNew
        //   .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
        //   .replace(/_(.*?)_/g, "<em>$1</em>")
        //   .replace(/\_(?=\w)/, "<em>")
        //   .replace(/(?<=\w)\_/, "</em>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll('"}', "")
        //   .replaceAll("\\n", "</br>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll("\\r", "")
        //   .replaceAll("\r", "");
        text = ReactHtmlParser(`<p>${textReplace}</p>`);

        return (
          <a
            href={`#comentario-${reply.id}`}
            className="comment-content__response"
            onClick={(e) => {
              e.preventDefault();
              handleComment(reply.id);
            }}
          >
            <div className="response-divider"></div>
            <div className="response-content">
              <Typography.H6 color="gray-180" weight={"bold"}>
                {formatEmoji(reply.username)}
              </Typography.H6>

              <Typography.H6 color="gray-180" weight={400}>
                {text.length > 150 ? `${text.slice(0, 150)}... ` : text}
              </Typography.H6>
            </div>
          </a>
        );
      } else {
        // const text = tratarBOT(reply.mensagem);
        let textNew = unicodeToChar(reply.mensagem);
        let textReplace = tratarUnderline(textNew);
        // let textReplace = textNew
        //   .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
        //   .replace(/_(.*?)_/g, "<em>$1</em>")
        //   .replace(/\_(?=\w)/, "<em>")
        //   .replace(/(?<=\w)\_/, "</em>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll('"}', "")
        //   .replaceAll("\\n", "</br>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll("\\r", "")
        //   .replaceAll("\r", "");

        const textExhib = ReactHtmlParser(`<p>${textReplace}</p>`);

        return (
          <a
            href={`#comentario-${reply.id}`}
            className="comment-content__response"
            onClick={(e) => {
              e.preventDefault();
              handleComment(reply.id);
            }}
          >
            <div className="response-divider"></div>
            <div className="response-content">
              <Typography.H6 color="gray-180" weight={"bold"}>
                {formatEmoji(reply.username)}
              </Typography.H6>

              <Typography.H6 color="gray-180" weight={400}>
                {textExhib.length > 150
                  ? `${textExhib.slice(0, 150)}... `
                  : textExhib}
              </Typography.H6>
            </div>
          </a>
        );
      }
    }
  }

  function renderFileComment() {
    if (attachment) {
      if (commentImg) {
        return (
          <CommentImage
            content={[{ file: attachment }]}
            linkImg={attachment ? "" : text}
          />
        );
      } else if (commentVideo) {
        return (
          <div className="bubble-media__video">
            <video className="bubble-media__video-frame" controls>
              <source
                className="bubble-media__video-file"
                src={`${urlIngWeb + attachment.path_arquivos}`}
                type={`${attachment.type}`}
              />
              Seu navegador nao suporta esse tipo de arquivo.
            </video>
          </div>
        );
      } else {
        return (
          <AttachTypeFiles
            files={attachment}
            type="comment"
            limit={3}
            className="comment-carousel"
            download
          />
        );
      }
    } else {
      return (
        <AttachTypeFiles
          files={attachment || text}
          type="comment"
          limit={3}
          className="comment-carousel"
          download
        />
      );
    }
  }

  function renderFooter() {
    const isStatusOfErrorInSendMessage =
      connection_platform.isStatusOfErrorInSendMessage;
    if (isStatusOfErrorInSendMessage) {
      return (
        <div className="comment-footer">
          <Typography.Paragraph color="gray-200">
            {date.horaEnvio}
          </Typography.Paragraph>
          {!date.horaEnvio || date.horaError ? (
            <ErrorCircle />
          ) : date.horaLida !== null ? (
            <>
              <Tick />
            </>
          ) : (
            <Tick className="gray-tick" />
          )}
        </div>
      );
    } else {
      return (
        <div className="comment-footer">
          <Typography.Paragraph color="gray-200">
            {date.horaEnvio}
          </Typography.Paragraph>
          {date.horaLida !== null ? (
            <>
              <Tick />
            </>
          ) : (
            <Tick className="gray-tick" />
          )}
        </div>
      );
    }
  }

  function renderButtons() {
    if (buttons) {
      return (
        <div className="comment-buttons">
          {buttons.map((button) => {
            let key = "";
            let textButton = "";
            let titleFlowCTA = "";
            let color = "";
            if (button.reply) {
              key = button.reply.id;
              textButton = unicodeToChar(button.reply.title);
            } else if (parseInt(mimetypeId) === 37) {
              if (button.title) {
                key = button.payload;
                textButton = unicodeToChar(button.title);
              } else {
                key = id;
                textButton = "";
              }
            } else if (parseInt(mimetypeId) === 50) {
              key = id;
              textButton = unicodeToChar(button.text);
              titleFlowCTA = unicodeToChar(button.flowCta);
            } else {
              key = button.payload;
              textButton = unicodeToChar(button.text);
            }

            if (parseInt(mimetypeId) === 37) {
              let menuButtons = button.rows || button.items;
              if (parseInt(botId) === 175 && menuButtons) {
                return (
                  <div className="comment-buttons__item-list" key={key}>
                    <Typography.H6 weight={400} color="gray-180">
                      {textButton}
                    </Typography.H6>
                    <div className="comment-buttons__item">
                      <div className="list-rows">
                        {menuButtons.map((row) => (
                          <div className="list-rows_item" key={row.id}>
                            <Typography.H5
                              weight={500}
                              color={
                                buttonResponse
                                  ? unicodeToChar(
                                      buttonResponse,
                                    ).toLowerCase() ===
                                      unicodeToChar(row.title).toLowerCase() ||
                                    buttonResponse === row.id
                                    ? `blue-selected-5`
                                    : "gray-125"
                                  : `blue-selected-5`
                              }
                            >
                              • {row.title}
                            </Typography.H5>
                            <Typography.H6
                              weight={400}
                              color={
                                buttonResponse
                                  ? unicodeToChar(
                                      buttonResponse,
                                    ).toLowerCase() ===
                                      unicodeToChar(row.title).toLowerCase() ||
                                    buttonResponse === row.id
                                    ? "gray-180"
                                    : "gray-125"
                                  : `gray-180`
                              }
                            >
                              {row.description}
                            </Typography.H6>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              } else if (!button.title && menuButtons) {
                return menuButtons.map((row) => (
                  <div className="comment-buttons__item" key={row.id}>
                    <Typography.H5
                      weight={500}
                      color={
                        buttonResponse
                          ? unicodeToChar(buttonResponse) ===
                              unicodeToChar(row.title) ||
                            buttonResponse === row.id
                            ? `blue-selected-5`
                            : "gray-125"
                          : `blue-selected-5`
                      }
                    >
                      • {row.title}
                    </Typography.H5>
                  </div>
                ));
              } else {
                return (
                  <div className="comment-buttons__item" key={key}>
                    <Typography.H5
                      weight={500}
                      color={
                        buttonResponse
                          ? unicodeToChar(buttonResponse) === textButton ||
                            buttonResponse === key
                            ? `blue-selected-5`
                            : "gray-125"
                          : `blue-selected-5`
                      }
                    >
                      • {textButton}
                    </Typography.H5>
                  </div>
                );
              }
            } else if (parseInt(mimetypeId) === 50) {
              return (
                <div className="comment-buttons__item-list" key={key}>
                  <Typography.H6 weight={400} color="gray-180">
                    {textButton}
                  </Typography.H6>
                  <div className="comment-buttons__item center-btn">
                    <div className="list-rows">
                      <div className="list-rows_item" key={parseInt(botId)}>
                        <Typography.H5 weight={500} color={"gray-125"}>
                          {titleFlowCTA}
                        </Typography.H5>
                      </div>
                    </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div className="comment-buttons__item" key={key}>
                  <Typography.H5
                    weight={500}
                    color={
                      buttonResponse
                        ? unicodeToChar(buttonResponse) === textButton ||
                          buttonResponse === key
                          ? `blue-selected-5`
                          : "gray-125"
                        : `blue-selected-5`
                    }
                  >
                    {textButton}
                  </Typography.H5>
                </div>
              );
            }
          })}
        </div>
      );
    } else if (contactInfo) {
      const phonesWhats = contactInfo.phones
        ? contactInfo.phones.filter((phone) => phone.wa_id)
        : [];

      return (
        <div className="comment-buttons contact-info">
          <div className="comment-buttons__item ">
            {contactInfo.phones && contactInfo.phones.length > 1 ? (
              <Popover
                trigger="click"
                placement="right"
                interactive={true}
                content={
                  <div className="popover-comment">
                    {contactInfo.phones.map((phone) => (
                      <div
                        className="popover-comment__item"
                        onClick={(e) => {
                          solicitarChamadaAtiva(
                            e,
                            1,
                            formatarNumeros(phone.phone),
                          );
                          hide();
                        }}
                      >
                        <Typography.H5 color={"gray-180"} key={phone.waid}>
                          {formatarNumeros(phone.phone)}
                        </Typography.H5>
                      </div>
                    ))}
                  </div>
                }
              >
                <Typography.H5 weight={500} color={`blue-selected-5`}>
                  Ligar
                </Typography.H5>
              </Popover>
            ) : (
              <div
                onClick={(e) =>
                  solicitarChamadaAtiva(
                    e,
                    1,
                    contactInfo.phones
                      ? formatarNumeros(contactInfo.phones[0].phone)
                      : "",
                  )
                }
              >
                <Typography.H5 weight={500} color={`blue-selected-5`}>
                  Ligar
                </Typography.H5>
              </div>
            )}
          </div>
          {contactInfo.phones && phonesWhats.length > 0 && (
            <div className="comment-buttons__item">
              {contactInfo.phones && phonesWhats.length > 1 ? (
                <Popover
                  trigger="click"
                  placement="right"
                  interactive={true}
                  content={
                    <div className="popover-comment">
                      {contactInfo.phones &&
                        phonesWhats.map((phone) => (
                          <div
                            className="popover-comment__item"
                            onClick={(e) => {
                              solicitarChamadaAtiva(
                                e,
                                5,
                                formatarNumeros(phone.phone),
                              );
                              hide();
                            }}
                          >
                            <Typography.H5 color={"gray-180"} key={phone.waid}>
                              {formatarNumeros(phone.phone)}
                            </Typography.H5>
                          </div>
                        ))}
                    </div>
                  }
                >
                  <Typography.H5 weight={500} color={`blue-selected-5`}>
                    Iniciar conversa
                  </Typography.H5>
                </Popover>
              ) : (
                <div
                  onClick={(e) =>
                    solicitarChamadaAtiva(
                      e,
                      5,
                      contactInfo.phones
                        ? formatarNumeros(phonesWhats[0].phone)
                        : "",
                    )
                  }
                >
                  <Typography.H5 weight={500} color={`blue-selected-5`}>
                    Iniciar conversa
                  </Typography.H5>
                </div>
              )}
            </div>
          )}

          {contactInfo.emails && (
            <div className="comment-buttons__item">
              {contactInfo.emails.length > 1 ? (
                <Popover
                  trigger="click"
                  placement="right"
                  interactive={true}
                  content={
                    <div className="popover-comment">
                      {contactInfo.emails.map((emails) => (
                        <div
                          className="popover-comment__item"
                          onClick={(e) => {
                            // solicitarChamadaAtiva(e, 3, emails.email);
                            hide();
                          }}
                        >
                          <a href={"mailto:" + emails.email}>
                            <Typography.H5
                              color={"gray-180"}
                              key={emails.email}
                            >
                              {emails.email}
                            </Typography.H5>
                          </a>
                        </div>
                      ))}
                    </div>
                  }
                >
                  <Typography.H5 weight={500} color={`blue-selected-5`}>
                    Enviar email
                  </Typography.H5>
                </Popover>
              ) : (
                <div
                // onClick={(e) => {
                //   solicitarChamadaAtiva(e, 3, contactInfo.emails[0].email);
                // }}
                >
                  <a href={"mailto:" + contactInfo.emails[0].email}>
                    <Typography.H5 weight={500} color={`blue-selected-5`}>
                      Enviar email
                    </Typography.H5>
                  </a>
                </div>
              )}
            </div>
          )}

          {contactInfo.phones && contactInfo.phones.length > 1 ? (
            <>
              <div className="comment-buttons__item">
                <Popover
                  trigger="click"
                  placement="right"
                  interactive={true}
                  content={
                    <div className="popover-comment">
                      {contactInfo.phones.map((phone) => (
                        <div
                          className="popover-comment__item"
                          onClick={() => {
                            contactLinkAdd(
                              { telefone: formatarNumeros(phone.phone) },
                              "link",
                            );
                            hide();
                          }}
                        >
                          <Typography.H5 color={"gray-180"} key={phone.waid}>
                            {formatarNumeros(phone.phone)}
                          </Typography.H5>
                        </div>
                      ))}
                    </div>
                  }
                >
                  <Typography.H5 weight={500} color={`blue-selected-5`}>
                    Vincular contato existente
                  </Typography.H5>
                </Popover>
              </div>
              <div className="comment-buttons__item">
                <Popover
                  trigger="click"
                  placement="right"
                  interactive={true}
                  content={
                    <div className="popover-comment">
                      {contactInfo.phones &&
                        contactInfo.phones.map((phone) => (
                          <div
                            className="popover-comment__item"
                            onClick={() => {
                              contactLinkAdd(
                                { telefone: formatarNumeros(phone.phone) },
                                "add",
                              );
                              hide();
                            }}
                          >
                            <Typography.H5 color={"gray-180"} key={phone.waid}>
                              {formatarNumeros(phone.phone)}
                            </Typography.H5>
                          </div>
                        ))}
                    </div>
                  }
                >
                  <Typography.H5 weight={500} color={`blue-selected-5`}>
                    Salvar contato
                  </Typography.H5>
                </Popover>
              </div>
            </>
          ) : (
            <>
              <div
                className="comment-buttons__item"
                onClick={() => {
                  contactLinkAdd(
                    {
                      telefone: contactInfo.phones
                        ? formatarNumeros(contactInfo.phones[0].phone)
                        : "",
                    },
                    "link",
                  );
                }}
              >
                <Typography.H5 weight={500} color={`blue-selected-5`}>
                  Vincular contato existente
                </Typography.H5>
              </div>
              <div
                className="comment-buttons__item"
                onClick={() => {
                  contactLinkAdd(
                    {
                      telefone: contactInfo.phones
                        ? formatarNumeros(contactInfo.phones[0].phone)
                        : "",
                    },
                    "add",
                  );
                }}
              >
                <Typography.H5 weight={500} color={`blue-selected-5`}>
                  Salvar contato
                </Typography.H5>
              </div>
            </>
          )}
        </div>
      );
    }
  }

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: connection_platform.maps_apiKey,
  });

  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    const bounds = new window.google.maps.LatLngBounds({
      lat: location ? parseFloat(location.latitude) : 0,
      lng: location ? parseFloat(location.longitude) : 0,
    });
    // map.fitBounds(bounds);
    map.setZoom(14);
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  function renderMaps() {
    if (location) {
      const mapStyles = {
        height: "200px",
        width: "100%",
      };

      const defaultCenter = {
        lat: parseFloat(location.latitude),
        lng: parseFloat(location.longitude),
      };

      const handleMarkerClick = () => {
        const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${parseFloat(
          location.latitude,
        )},${parseFloat(location.longitude)}&key=${
          connection_platform.maps_apiKey
        }`;

        axios
          .get(geocodeUrl)
          .then((response) => {
            if (response.data.results.length > 0) {
              const formattedAddress =
                response.data.results[1].formatted_address;

              const url = `https://maps.google.com/maps/search/${encodeURIComponent(
                formattedAddress,
              )}/@${parseFloat(location.latitude)},${parseFloat(
                location.longitude,
              )},17z?hl=pt-BR`;

              window.open(url, "_blank");
            }
          })
          .catch((error) => {
            console.error("Erro ao obter endereço:", error);
          });
      };

      return isLoaded ? (
        <GoogleMap
          mapContainerStyle={mapStyles}
          center={defaultCenter}
          zoom={14}
          onLoad={onLoad}
          onUnmount={onUnmount}
          options={{
            // Configure as opções do mapa
            fullscreenControl: false, // Remova o botão de tela cheia
          }}
        >
          {/* Child components, such as markers, info windows, etc. */}
          <Marker
            onClick={handleMarkerClick}
            position={{
              lat: parseFloat(location.latitude),
              lng: parseFloat(location.longitude),
            }}
          />
        </GoogleMap>
      ) : (
        <div>Loading...</div>
      );
    }
  }

  const renderTippyCommentTypeTwo = () => {
    return (
      <Popover
        trigger="click"
        placement="bottom"
        interactive={true}
        content={
          <div className="popover-comment">
            {titleOptions && (
              <div
                className="popover-comment__item"
                onClick={() => {
                  handleReply({ id });
                  hide();
                }}
              >
                <Typography.H5 color="gray-180" weight="500">
                  Responder
                </Typography.H5>
              </div>
            )}
            {InfoUsers.permdownload && (
              <div
                className="popover-comment__item"
                onClick={() => {
                  setStatusDownload("Downloading...");
                  onDownload();
                }}
              >
                <Typography.H5 color="gray-180" weight="500">
                  {statusDownload}
                </Typography.H5>
              </div>
            )}
          </div>
        }
      >
        <IconMoreVertical
          className="popover-comment-icon"
          onClick={() => show()}
        />
      </Popover>
    );
  };

  const onDownload = async () => {
    await fetch(`${urlIngWeb + attachment.path_arquivos}`).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = attachment.name;
        a.click();
      });
    });
    setStatusDownload("Download");
    hide();
  };

  const renderContactInfo = () => {
    if (contactInfo) {
      return (
        <div className="contact-info_container">
          <UserPhoto size="large" />
          <div className="contact-infos">
            <Typography.H5 color={"gray-180"} weight={700}>
              {contactInfo.name.formattedName}
              {contactInfo.name.formatted_name}
            </Typography.H5>
            {contactInfo.phones &&
              contactInfo.phones.map((phone) => (
                <Typography.H5 color={"gray-180"} key={phone.waid}>
                  {phone.phone}
                </Typography.H5>
              ))}
            {contactInfo.emails &&
              contactInfo.emails.map((email) => (
                <Typography.H5 color={"gray-180"} key={email.email}>
                  {email.email}
                </Typography.H5>
              ))}
            {(contactInfo.addresses || contactInfo.emails) && <br />}
            {contactInfo.addresses &&
              contactInfo.addresses.map((address) => (
                <Typography.H5 color={"gray-180"} key={address.street}>
                  <b>Endereço: </b>
                  {address.street} {!address.street ? address.state : ""},{" "}
                  {!address.street ? address.country : ""}
                </Typography.H5>
              ))}
          </div>
        </div>
      );
    }
  };

  //USE EFFECTS

  useEffect(() => {
    if (mimetype) {
      const typeConfirmImg = mimetype.typename.includes("image");

      const typeConfirmVideo = mimetype.typename.includes("video");

      if (typeConfirmImg) {
        setCommentImg(true);
      } else {
        setCommentImg(false);
      }
      if (typeConfirmVideo) {
        setCommentVideo(true);
      } else {
        setCommentVideo(false);
      }
    }

    if (attachment) {
      const typeConfirmImg = attachment.type.includes("image");

      const typeConfirmVideo = attachment.type.includes("video");

      if (typeConfirmImg) {
        setCommentImg(true);
      } else {
        setCommentImg(false);
      }
      if (typeConfirmVideo) {
        setCommentVideo(true);
      } else {
        setCommentVideo(false);
      }
    }
  }, [attachment, mimetype]);

  //UseEffect que recebe o filtro de palavras e com base nele coloca um marcador de texto em volta da palavra que foi filtrada.
  // useEffect(() => {
  //   let currentComment = interactionComment;

  //   if (inputSearch) {
  //     const indexes = [];
  //     let i = 0;
  //     while (i < currentComment.length) {
  //       if (
  //         currentComment.toLowerCase().indexOf(inputSearch.toLowerCase(), i) !==
  //         -1
  //       ) {
  //         indexes.push(
  //           currentComment.toLowerCase().indexOf(inputSearch.toLowerCase(), i)
  //         );
  //         i =
  //           currentComment.toLowerCase().indexOf(inputSearch.toLowerCase(), i) +
  //           1;
  //       } else {
  //         i = currentComment.length;
  //       }
  //     }
  //     const words = [];

  //     for (const index of indexes) {
  //       const partName = currentComment.substr(index, inputSearch.length);
  //       words.push(partName);
  //     }

  //     const newWords = words.filter((item, i) => {
  //       return words.indexOf(item) === i;
  //     });
  //     const newWordsOrder = newWords.sort((a, b) => a.localeCompare(b));
  //     for (const item of newWordsOrder) {
  //       currentComment = currentComment.replaceAll(
  //         item,
  //         `<mark>${item}</mark>`
  //       );
  //     }

  //   }

  //   currentComment = currentComment.replaceAll(` `, `&nbsp;`);

  //   setInteractionComment(`<p>${currentComment}</p>`);
  // }, [inputSearch]);

  // useEffect(() => {
  //   let currentComment = Highlight(interactionComment, inputSearch);

  //   setInteractionComment(currentComment);

  //   // if (inputSearch && marker) {
  //   //   marker.mark(inputSearch);
  //   // }

  //   // if (!inputSearch && marker) {
  //   //   marker.mark(inputSearch);
  //   // }
  // }, [inputSearch]);

  useEffect(() => {
    // Função para encontrar e marcar as partes correspondentes

    const getText = isJson(text) === true ? tratarBOT(text) : text;
    const formatText = escapeHtml(unicodeToChar(getText));

    const highlightText = () => {
      if (inputSearch && !attachment) {
        setStringAnterior(inputSearch);
        const regex = new RegExp(inputSearch, "gi");
        // const regex = new RegExp(`(${inputSearch})`, "i");
        // const markedHtml = formatText.split(regex).map((chunk, index) => {
        //   if (chunk.toLowerCase() === inputSearch.toLowerCase()) {
        //     return <mark key={index}>{chunk}</mark>;
        //   }
        //   return chunk;
        // });
        const markedHtml = formatText.replace(
          regex,
          (match) => `<b class="highlighted">${match}</b>`,
        );
        const newText = tratarUnderline(markedHtml);
        // const newText = unicodeToChar(markedHtml)
        //   .replaceAll("\r\n", "</br>")
        //   .replace(/(?:\*)([^*\n]+)(?:\*)/g, "<strong>$1</strong>")
        //   .replace(/_(.*?)_/g, "<em>$1</em>")
        //   .replace(/\_(?=\w)/, "<em>")
        //   .replace(/(?<=\w)\_/, "</em>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll('"}', "")
        //   .replaceAll("\\n", "</br>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll("\\r", "")
        //   .replaceAll("\r", "");

        setInteractionComment(newText);
        // setInteractionComment(`<p>${newText}</p>`);
      } else if (stringAnterior && !inputSearch) {
        setStringAnterior(inputSearch);
        const newText = tratarUnderline(formatText);
        // const newText = unicodeToChar(formatText)
        //   .replaceAll("\r\n", "</br>")
        //   .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
        //   .replace(/_(.*?)_/g, "<em>$1</em>")
        //   .replace(/\_(?=\w)/, "<em>")
        //   .replace(/(?<=\w)\_/, "</em>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll('"}', "")
        //   .replaceAll("\\n", "</br>")
        //   .replaceAll("\n", "</br>")
        //   .replaceAll("\\r", "")
        //   .replaceAll("\r", "");

        setInteractionComment(newText);
      }
    };

    highlightText();
  }, [inputSearch]);

  useEffect(() => {
    if (mimetypeId === 30 && isJson(text) === true) {
      tratarBOT2(textInteraction);
    }

    // if(mimetypeId === 37){
    //   if(isJson(text) === true){
    //     tratarBOT2(textInteraction);
    //   }
    // }

    if (
      typeName === "Interactive" &&
      isJson(text.replace(/\r?\n/g, "\\n")) === true
    ) {
      tratarBOT2(textInteraction);
    }

    if (typeName === "location" && isJson(text) === true) {
      tratarBOT2(textInteraction);
    }

    if (mimetypeId === 45) {
      let recipients = [];
      if (allInfo.id) {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/list-infomail-byid?id=${allInfo.id}`,
          )
          .then((response) => {
            if (response.data !== "") {
              let retorno = response.data[0].email.split("Â¿");
              retorno.map((todo) => {
                let stringSplit = todo.split("Â§");
                let type = 0;
                if (stringSplit[1] === "4") {
                  type = 0;
                } else if (stringSplit[1] === "2") {
                  type = 2;
                } else if (stringSplit[1] === "1") {
                  type = 1;
                } else if (stringSplit[1] === "3") {
                  type = 3;
                }
                recipients.push({
                  label: stringSplit[0],
                  type: type,
                });
              });
            }
            let attachments = [];
            axios
              .get(
                `${connection_platform.type_connect}://${pathname}:${port}/conn/getattachmentemail?id=${allInfo.id}`,
              )
              .then((response) => {
                attachments = response.data;
                setInteractionEmail({
                  ...interactionEmail,
                  attachments: attachments,
                  recipients: recipients,
                });
              });
          });
      }
    }
  }, []);

  // let textPrincipal = unicodeToChar(interactionComment)
  //   .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
  //   .replace(/\_(?=\w)/, "<em>")
  //   .replace(/(?<=\w)\_/, "</em>")
  //   .replaceAll("\n", "</br>")
  //   .replaceAll('"}', "")
  //   .replaceAll("\\n", "</br>")
  //   .replaceAll("\n", "</br>")
  //   .replaceAll("\\r", "")
  //   .replaceAll("\r", "");

  // let caption = allInfo.caption
  //   ? unicodeToChar(allInfo.caption)
  //       .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
  //       .replace(/\_(?=\w)/, "<em>")
  //       .replace(/(?<=\w)\_/, "</em>")
  //       .replaceAll("\n", "</br>")
  //       .replaceAll('"}', "")
  //       .replaceAll("\\n", "</br>")
  //       .replaceAll("\n", "</br>")
  //       .replaceAll("\\r", "")
  //       .replaceAll("\r", "")
  //   : "";

  function fixAndParseJson(input) {
    try {
      // Tenta primeiro fazer parse normal
      return JSON.parse(input);
    } catch (err1) {
      try {
        // Tenta corrigir escapes desnecessários e depois parsear
        const fixed = input.replace(/\\"/g, '"');
        return JSON.parse(fixed);
      } catch (err2) {
        console.error(
          "Não foi possível fazer o parse do JSON nem com correção.",
        );
        return null;
      }
    }
  }

  const renderMenuList = () => {
    console.log("@#$#K@K#", type);
    console.log("@#$#K@K#", allInfo);
    const typeComment = () => {
      let htmlText = tratarUnderline(interactionComment);

      // if (!!htmlText && typeof htmlText === "string") {
      // htmlText = htmlText.replace(/"/g, "").replace(/\\/g, "");
      // }

      return (
        <div className="comment-content">
          {renderCommentAnswered()}
          {renderMaps()}
          {renderContactInfo()}
          {attachment && attachment.path_arquivos && (
            <div className="comment-content-buttons">
              <div
                className={`comment-content-buttons-attachment-list ${
                  attachment ? "column" : ""
                }`}
              >
                {renderFileComment()}
              </div>
            </div>
          )}
          <div
            className="comment-content__text"
            style={{ pointerEvents: "none" }}
            onClick={(event) => blockClick(event)}
          >
            <Typography.H5 color="gray-180" weight={400}>
              {ReactHtmlParser(`<p>${htmlText}<p/>`)}
              {/* {ReactHtmlParser(`<p>Não foi possível exibir a mensagem.<p/>`)} */}
            </Typography.H5>
          </div>
        </div>
      );
    };
    return (
      <div
        className={`interaction-comment ${
          direction === "left"
            ? typemon !== 0
              ? "yellow-color"
              : "blue-color"
            : " "
        } ${location ? "maps-width" : ""} ${
          type === "attachment"
            ? "comment-length-normal"
            : "comment-length-alternate"
        }`}
        id={`comentario-${id}`}
      >
        <div className="comment-information">{renderTitleComment()}</div>
        <div className="comment-principal">
          {typeComment()}
          {buttons && renderButtons()}
          {contactInfo && renderButtons()}
        </div>
      </div>
    );
  };

  const renderInteractionComment = () => {
    // console.log("@#$#K@K#", type)
    // console.log("@#$#K@K#", allInfo)
    const typeComment = () => {
      if (type === "attachment") {
        if (typeName === "audio" || typeName === "voice") {
          return (
            <div className="comment-content">
              {renderCommentAnswered()}
              {attachment && attachment.path_arquivos && (
                <Audio link={attachment.path_arquivos} />
              )}
            </div>
          );
        } else {
          let htmlText = tratarUnderline(interactionComment);
          // let htmlText = unicodeToChar(interactionComment)
          //   .replace(/(?:\*)([^*\n]+)(?:\*)/g, "<strong>$1</strong>")
          //   .replace(/_(.*?)_/g, "<em>$1</em>")
          //   .replace(/\_(?=\w)/, "<em>")
          //   .replace(/(?<=\w)\_/, "</em>")
          //   .replaceAll("\n", "</br>")
          //   .replaceAll('"}', "")
          //   .replaceAll("\\n", "</br>")
          //   .replaceAll("\n", "</br>")
          //   .replaceAll("\\r", "")
          //   .replaceAll("\r", "");
          return (
            <div className="comment-content">
              <div className="comment-content__files">
                {renderFileComment()}
              </div>
              {allInfo.caption && (
                <div
                  className="comment-content__text"
                  style={{ pointerEvents: "none" }}
                  onClick={(event) => blockClick(event)}
                >
                  <Typography.H5 color="gray-180" weight={400}>
                    {ReactHtmlParser(`<p>${htmlText}<p/>`)}
                  </Typography.H5>
                </div>
              )}
            </div>
          );
        }
      } else {
        let htmlText = tratarUnderline(interactionComment);
        // let htmlText = unicodeToChar(interactionComment)
        // .replace(/(?:\*)([^*\n]+)(?:\*)/g, "<strong>$1</strong>")
        // .replace(/_(.*?)_/g, "<em>$1</em>")
        // .replace(/\_(?=\w)/, "<em>")
        // .replace(/(?<=\w)\_/, "</em>")
        // .replaceAll("\n", "</br>")
        // .replaceAll('"}', "")
        // .replaceAll("\\n", "</br>")
        // .replaceAll("\n", "</br>")
        // .replaceAll("\\r", "")
        // .replaceAll("\r", "");
        if (!!htmlText && typeof htmlText === "string") {
          htmlText = htmlText.replace(/"/g, "").replace(/\\/g, "");
        }

        return (
          <div className="comment-content">
            {renderCommentAnswered()}
            {renderMaps()}
            {renderContactInfo()}
            {attachment && attachment.path_arquivos && (
              <div className="comment-content-buttons">
                <div
                  className={`comment-content-buttons-attachment-list ${
                    attachment ? "column" : ""
                  }`}
                >
                  {renderFileComment()}
                </div>
              </div>
            )}
            <div
              className="comment-content__text"
              style={{ pointerEvents: "none" }}
              onClick={(event) => blockClick(event)}
            >
              <Typography.H5 color="gray-180" weight={400}>
                {ReactHtmlParser(`<p>${htmlText}<p/>`)}
              </Typography.H5>
            </div>
          </div>
        );
      }
    };

    return (
      <div
        className={`interaction-comment ${
          direction === "left"
            ? typemon !== 0
              ? "yellow-color"
              : "blue-color"
            : " "
        } ${location ? "maps-width" : ""} ${
          type === "attachment"
            ? "comment-length-normal"
            : "comment-length-alternate"
        }`}
        id={`comentario-${id}`}
      >
        <div className="comment-information">{renderTitleComment()}</div>
        <div className="comment-principal">
          {typeComment()}
          {buttons && renderButtons()}
          {contactInfo && renderButtons()}
        </div>
      </div>
    );
  };

  if (mimetypeId === 45) {
    return <InteractionEmail mail={interactionEmail} />;
  } else {
    return (
      <div
        className={`interaction-comment-container ${
          direction === "left" ? "reverse-row" : ""
        } ${date.dia ? "column" : ""} `}
      >
        {date.dia && (
          <div className="time">
            {format(date.dia, "dd 'de' MMMM", { locale: ptBR })}
          </div>
        )}
        {renderInteractionComment()}

        {/* <ImageProfile
          profile={{
            nome_usuario: formatEmoji(name) ?? "Não registrado",
          }}
          client={direction === "left" ? true : false}
          tooltip
          className="comment-list__profileImage"
          iconHistory={!name && "user"}
        /> */}
      </div>
    );
  }
}

export default InteractionComment;
